import { useMutation, useQuery, useQueryClient } from 'react-query';
import { createChannelTemplate, listChannelTemplates, type CreateTemplateRequest } from '@/services/templatesService';
import type { ChannelType } from '@/services/channelsService';

export interface UseTemplatesParams {
  tenantId?: string;
  channel?: ChannelType;
  enabled?: boolean;
}

export function useTemplatesByChannel(params: UseTemplatesParams = {}) {
  const { tenantId, channel, enabled = true } = params;

  return useQuery({
    queryKey: ['templates', { tenantId, channel }],
    queryFn: async () => {
      const res = await listChannelTemplates({ channel });
      return res.data;
    },
    enabled,
  });
}

export function useCreateTemplate() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateTemplateRequest) => {
      const res = await createChannelTemplate(payload);
      return res.data;
    },
    onSuccess: (_data, variables) => {
      qc.invalidateQueries(['templates']);
      qc.invalidateQueries(['templates', { tenantId: undefined, channel: variables.channel }]);
    },
  });
}
